var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"email_box"},[_c('div',{staticClass:"email_box--main"},[_vm._t("default")],2),_vm._v(" "),(!_vm.hideFooter)?_c('div',{staticClass:"email_box--footer flex flex-vertical-center flex-between",staticStyle:{"width":"100%"}},[_vm._t("footer")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }